import React from 'react';
import { motion } from 'framer-motion';

const InteractiveMap = () => {
  return (
    <motion.div 
      className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 h-[400px] relative bg-gray-50"
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.84074819777!2d75.8690369757657!3d11.19941198897587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba65d8363a00001%3A0x633464522437077a!2sRamanattukara%2C%20Kozhikode%2C%20Kerala!5e0!3m2!1sen!2sin!4v1706090000000!5m2!1sen!2sin" 
        width="100%" 
        height="100%" 
        style={{ border: 0 }} 
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade"
        title="Teqvis Location"
        className="filter grayscale-[0.2] hover:grayscale-0 transition-all duration-500"
      ></iframe>
      
      <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-white/50 max-w-xs">
        <p className="text-sm font-semibold text-gray-900">Visit Our Office</p>
        <p className="text-xs text-gray-600 mt-1">Ramanattukara, Calicut, Kerala</p>
      </div>
    </motion.div>
  );
};

export default InteractiveMap;
